import { message } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { logoutAuth } from "../../store/actions/auth.action";

const Logout = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    try {
      dispatch(logoutAuth());
      sessionStorage.removeItem("token");
      message.success(t("logout.message"));
      window.location.href = "/";
    } catch (error) {
      console.error(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div>{t("logout.title")}</div>;
};

export default Logout;
